<template>
	<div class="template money">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span> </label>
			<input class="input_value" :change="changeVal()" v-model="dataVal.Value" type="text" placeholder="请输入" />
		</div>
	</div>
</template>

<script>
	export default{
		props: ['dataVal'],
		data(){
			return{
				
			}
		},
		mounted() {

		},
		methods: {
			changeVal() {
				var value = this.dataVal.Value;
				if(value == null){
					return;
				}
				this.dataVal.Value = (value.match(/^\d{0,9}(\.\d{0,2}){0,1}/g)[0]) || null;
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';
</style>